import { Row } from "react-bootstrap";
import exclamation from "../../../../assets/images/exclamation-circle.png";
import   '../utils/index.css';
import { Switch } from "antd";
const Notification = () => {
   const onChange = (checked: Boolean) => {
    console.log(`switch to ${checked}`);
  };
return(
    <Row>
  <div className=" px-3">
            <div
              style={{
                padding: "5px",
                backgroundColor: "#FFFFFF",
                border: "1px solid #E3E3E3",
                boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
              }}
            >
            <span style={{
            marginLeft:'15px',
            width: "100%",
            backgroundColor: "#FFFFFF",
            fontFamily: "Poppins",
            fontSize: "20px",
            fontWeight: "500",
            color: "#070707",
            borderColor: "#0000001A",
          
          }}> Canaux de notification
          </span>
  </div> 
    <div
      style={{
      padding: "20px",
      backgroundColor: "#FFFFFF",
      border: "1px solid #E3E3E3",
      boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
      }}
    >
    <div style={{  display: "flex", alignItems: "center", gap: "10px" }}>
      <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between", // le label à gauche, le switch à droite
        width: "100%", // pour occuper toute la ligne si besoin
      }}
    >
      <label
        htmlFor="Pourlesmontantsélevés"
        style={{
          fontFamily: "Poppins",
          fontSize: "18px",
          fontWeight: "400",
          color: "#141414",
          cursor: "pointer",
        }}
      >
       Notification par email
      </label>

      <Switch defaultChecked onChange={onChange} style={{transform: "scale(0.8)"}} />
    </div>
  </div>
  <span style={{color:"#07070773",fontSize:"14px",fontWeight:'400',fontFamily:'Poppins'}}>admin@paxity.com</span>
  
      <div className="row" style={{ display: "flex", gap: "15px",marginTop:'15px' }}>
        {/* Premier input */}
         <div style={{  display: "flex", alignItems: "center", gap: "10px" }}>
      <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between", // le label à gauche, le switch à droite
        width: "100%", // pour occuper toute la ligne si besoin
      }}
    >
      <label
        htmlFor="Pourlesmontantsélevés"
        style={{
          fontFamily: "Poppins",
          fontSize: "18px",
          fontWeight: "400",
          color: "#141414",
          cursor: "pointer",
        }}
      >
       Notification sms
      </label>

      <Switch defaultChecked onChange={onChange} style={{transform: "scale(0.8)"}} />
    </div>
  </div>
  
      </div>
       <span style={{color:"#07070773",fontSize:"14px",fontWeight:'400',fontFamily:'Poppins'}}>+221 77 899 87 86</span>
        <hr style={{color:'#E3E3E3',border: '1px solid #E3E3E3'}}></hr>
 <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between", // le label à gauche, le switch à droite
        width: "100%", // pour occuper toute la ligne si besoin
      }}
    >
      <label
        htmlFor="Pourlesmontantsélevés"
        style={{
          fontFamily: "Poppins",
          fontSize: "18px",
          fontWeight: "400",
          color: "#141414",
          cursor: "pointer",
        }}
      >
       Types d’alertes activités
      </label>
    </div>
    <div style={{ marginTop: "10px", display: "flex", alignItems: "center", gap: "10px" }}>
  <input
    type="checkbox"
    id="PourMontantsEleves"
    style={{
      width: "18px",
      height: "18px",
      cursor: "pointer",
    }}
  />
  <div>
    <label
      htmlFor="Pourlesmontantsélevés"
      style={{
        fontFamily: "Poppins",
        fontSize: "15px",
        fontWeight: "400",
        color: "#070707",
        cursor: "pointer",
      }}
    >
     Alertes de sécurité
    </label>
  </div>
</div>
<div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
  <input
    type="checkbox"
    id="PourMontantsEleves"
    style={{
      width: "18px",
      height: "18px",
      cursor: "pointer",
    }}
  />
  <div>
    <label
      htmlFor="Pourlesmontantsélevés"
      style={{
        fontFamily: "Poppins",
        fontSize: "15px",
        fontWeight: "400",
        color: "#070707",
        cursor: "pointer",
      }}
    >
     Transactions de montant elevé
    </label>
  </div>
</div>
<div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
  <input
    type="checkbox"
    id="PourMontantsEleves"
    style={{
      width: "18px",
      height: "18px",
      cursor: "pointer",
    }}
  />
  <div>
    <label
      htmlFor="Pourlesmontantsélevés"
      style={{
        fontFamily: "Poppins",
        fontSize: "15px",
        fontWeight: "400",
        color: "#070707",
        cursor: "pointer",
      }}
    >
    Lorems 
    </label>
  </div>
</div>
    </div>
  <div
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginTop: "25px",
    width: "100%",
  }}
>
</div>
</div>
  <div className=" px-3">
  {/* Section des paramètres visibles si isOpenS est vrai */}
  <div
              style={{
                padding: "5px",
                backgroundColor: "#FFFFFF",
                border: "1px solid #E3E3E3",
                boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
              }}
            >
            <span style={{
              marginLeft:'15px',
            width: "100%",
            backgroundColor: "#FFFFFF",
            fontFamily: "Poppins",
            fontSize: "20px",
            fontWeight: "500",
            color: "#070707",
            borderColor: "#0000001A",
            height: "40px",
          }}> Rapports automatiques
          </span>
  </div> 
    <div
      style={{
      padding: "20px",
      backgroundColor: "#FFFFFF",
      border: "1px solid #E3E3E3",
      boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
      }}
    >
 <div style={{  display: "flex", alignItems: "center", gap: "10px" }}>
      <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
      }}
    >
      <label
        htmlFor="Pourlesmontantsélevés"
        style={{
          fontFamily: "Poppins",
          fontSize: "18px",
          fontWeight: "400",
          color: "#141414",
          cursor: "pointer",
        }}
      >
       Rapports quotidiens
      </label>

      <Switch defaultChecked onChange={onChange}style={{transform: "scale(0.8)"}} />
    </div>
  </div>
  <span style={{color:'#07070773',fontWeight:'400',fontSize:'14px',fontFamily:'Poppins'}}>Synthèse des activités du jour</span>
   <div style={{  display: "flex", alignItems: "center", gap: "10px" }}>
      <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between", 
        width: "100%"
      }}
    >
      <label
        htmlFor="Pourlesmontantsélevés"
        style={{
          marginTop:'15px',
          fontFamily: "Poppins",
          fontSize: "18px",
          fontWeight: "400",
          color: "#141414",
          cursor: "pointer",
        }}
      >
       Rapports hebdomadaires
      </label>

      <Switch defaultChecked onChange={onChange}style={{transform: "scale(0.8)"}} />
    </div>
  </div>
  <span style={{color:'#07070773',fontWeight:'400',fontSize:'14px',fontFamily:'Poppins'}}>Analyse des performances de la semaine</span>
     <div style={{  display: "flex", alignItems: "center", gap: "10px" }}>
      <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between", 
        width: "100%"
      }}
    >
      <label
        htmlFor="Pourlesmontantsélevés"
        style={{
          marginTop:'15px',
          fontFamily: "Poppins",
          fontSize: "18px",
          fontWeight: "400",
          color: "#141414",
          cursor: "pointer",
        }}
      >
       Rapports mensuels
      </label>

      <Switch defaultChecked onChange={onChange}style={{transform: "scale(0.8)"}} />
    </div>
  </div>
  <span style={{color:'#07070773',fontWeight:'400',fontSize:'14px',fontFamily:'Poppins'}}>Bilan complet du mois</span>
     <div style={{  display: "flex", alignItems: "center", gap: "10px" }}>
      <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between", 
        width: "100%"
      }}
    >
      <label
        htmlFor="Pourlesmontantsélevés"
        style={{
          marginTop:'15px',
          fontFamily: "Poppins",
          fontSize: "18px",
          fontWeight: "400",
          color: "#141414",
          cursor: "pointer",
        }}
      >
      Destinataires de rapports
      </label>
    </div>
  </div>
  <div style={{border:'1px solid #E1E1E1'}}>
    <div  className=" labelDestinaire"><span className='addDestinataire' >-</span>  admin@paxity.com </div>
   <div  className=" labelDestinaire"><span className='addDestinataire' >-</span> manager@paxity.com </div>
    <div className=" labelDestinaire"><span className='addDestinataire' >-</span> finance@paxity.com </div>
  </div>
   <div  className=" labelD"><span className='addD' >+</span> Nouveau destinataire </div>
  </div>
  {/* Bouton Sauvegarder */}
  <div
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-end",
    marginTop: "25px",
    width: "100%",
  }}
>
  <div></div>
  <div style={{ display: "flex", alignItems: "center", gap: "10px",  marginTop: "20px", }}>
    <button
      type="button"
      className="btn btn-primary"
      style={{
        height: "40px",
        color: "#3761FF",
        backgroundColor: "#F2F5FF",
        borderColor: "#F2F5FF",
        borderRadius: "8px",
        fontFamily: "Poppins",
        fontSize: "15px",
        fontWeight: "500",
        padding: "0 15px",
        boxShadow: "0px 3px 8px rgba(0, 0, 0, 0.1)",
      }}
    >
      Réinitialiser
    </button>

    <button
      type="button"
      className="btn btn-primary"
      style={{
        height: "40px",
        color: "#FFFFFF",
        backgroundColor: "#3761FF",
        borderColor: "#3761FF",
        borderRadius: "8px",
        fontFamily: "Poppins",
        fontSize: "15px",
        fontWeight: "500",
        padding: "0 15px",
        boxShadow: "0px 3px 8px rgba(0, 0, 0, 0.1)",
      }}
      >
      Enregistrer
    </button>
  </div>
</div>
</div>
</Row>
);
};
export default Notification;
